import React from "react";
import styles from "./EmptyState.module.scss";

const EmptyState = ({ title, description, action }) => {
  return (
    <div className={styles.emptyState}>
      <div className={styles.iconWrap}>
        <span className="material-icons">search_off</span>
      </div>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
};

export default EmptyState;
